import { useCallback, useState } from 'react'
import { exportChartContainerAsPng } from '../../utils/exportChartAsPng'
import styles from './ChartExportButton.module.css'

interface ChartExportButtonProps {
  getContainer: () => HTMLElement | null
  filename: string
  label?: string
}

export function ChartExportButton({ getContainer, filename, label = 'Exportar PNG' }: ChartExportButtonProps) {
  const [isExporting, setIsExporting] = useState(false)

  const handleClick = useCallback(async () => {
    const container = getContainer()
    if (!container) {
      return
    }

    setIsExporting(true)

    try {
      await exportChartContainerAsPng(container, filename)
    } catch (error) {
      console.error('Falha ao exportar gráfico em PNG.', error)
      window.alert('Não foi possível exportar este gráfico em PNG.')
    } finally {
      setIsExporting(false)
    }
  }, [getContainer, filename])

  return (
    <button
      type="button"
      className={styles.exportButton}
      onClick={handleClick}
      disabled={isExporting}
      aria-label={label}
      title={label}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M12 4v11m0 0-4-4m4 4 4-4M5 19h14"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}
